module.exports = __webpack_public_path__ + "media/images/3-off-0d0ac3450a4f3ca1f152bd796d2f5775.png";